import { render, staticRenderFns } from "./TradeShow.vue?vue&type=template&id=0f8e64d7&"
import script from "./TradeShow.vue?vue&type=script&lang=js&"
export * from "./TradeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports